import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { formatAssistantRoomsOccupancyText } from 'tripPlanner/assistant/utils/assistantRoomOccupancyText'

interface ExperienceSearchDateRange {
  checkIn?: string
  checkOut?: string
}

function formatDateRangeSuffix({ checkIn, checkOut }: ExperienceSearchDateRange): string {
  return checkIn && checkOut ? `, ${checkIn} to ${checkOut}` : ''
}

// Included so a rooms-only reapply (same destination/dates, different occupancy) produces a
// displayText distinct from the original search -- otherwise the two are indistinguishable and
// the server's kind+displayText grouping silently absorbs the occupancy change into the earlier
// entry, losing the fact that the customer changed party size at all.
function formatOccupancySuffix(occupancies: Array<App.Occupants>): string {
  const occupancyText = formatAssistantRoomsOccupancyText(occupancies)
  return occupancyText ? `, ${occupancyText}` : ''
}

export function buildExperienceSearchSubmittedActivityEntry(
  searchQuery: string,
  dateRange: ExperienceSearchDateRange,
  occupancies: Array<App.Occupants>,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'experience_search_submitted',
    label: 'Searched experiences',
    displayText: boundActivityDisplayText(
      `Searched experiences for "${searchQuery}"${formatDateRangeSuffix(dateRange)}${formatOccupancySuffix(occupancies)}`,
    ),
    sourcePath: 'trip_planner.search.experience',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
